import { memo } from "react";
import PropTypes from "prop-types";
import ProgressiveImg from "app/pages/.shared/ProgressiveImg";

const IMG_SIZES = {
	medium: { width: 978 },
	small: { width: 768 },
	large: { width: 2880 },
	xlarge: { width: 2880 },
};

const SmartDPMarketingHeroImage = ({
	imageThumbnail,
	imageUrl,
	sizes,
	resolution,
	backgroundPosition,
	alt = "",
}) => {
	return (
		<ProgressiveImg
			sizes={sizes ? sizes : IMG_SIZES}
			resolution={resolution}
			thumbnail={imageThumbnail}
			src={imageUrl}
			backgroundPosition={backgroundPosition}
			quality="q_auto:best"
			fetchPriority="high"
			cover
			alt={alt}
			disableLazyLoad
		/>
	);
};

SmartDPMarketingHeroImage.propTypes = {
	imageThumbnail: PropTypes.string,
	imageUrl: PropTypes.string,
	sizes: PropTypes.object,
	resolution: PropTypes.string,
	backgroundPosition: PropTypes.string,
	alt: PropTypes.string,
};

export default memo(SmartDPMarketingHeroImage);
